// This is required for IE (previously used as babel-polyfill, which is now deprecated)
// Also imported in src/widget/boot.js (for Widget)
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Also imported in src/widget/boot.js (for Widget)
import elementClosest from 'element-closest'

// This is a IE11 fix that is needed for slate editor to work
// Slate editor is currently not used, but it might still be needed for something else
elementClosest(window)

/**
 * Add "intl" as polyfill to solve this error:
 * [React Intl] The `Intl` APIs must be available in the runtime, and do not appear to be built-in. An `Intl` polyfill should be loaded.
 * See: http://formatjs.io/guides/runtime-environments/
 */
if (!global.Intl) {
  global.Intl = require('intl')
}
if (!window.Intl) {
  window.Intl = require('intl')
}

/**
 * Custom Replace all polyfill
 *
 * @see https://stackoverflow.com/questions/1144783/how-to-replace-all-occurrences-of-a-string-in-javascript
 *
 * NOTE: For now it uses the split + join method which might be somewhat slower then the Regexp version, but it's safer.
 * TODO: Later see about getting a proper polyfill for this.
 */
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(search, replacement) {
    var target = this
    return target.split(search).join(replacement)
  }
}
